import { render, staticRenderFns } from "./vView.vue?vue&type=template&id=28025c10&scoped=true&"
import script from "./vView.vue?vue&type=script&lang=js&"
export * from "./vView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28025c10",
  null
  
)

export default component.exports